/**
 * Access key for the embeddable AI map (`/ai-map-iframe`).
 *
 * The key is passed as a top-level query param, before the hash router part:
 *   https://feat1.scandpe.fr/?key=<KEY>#/ai-map-iframe/
 * It is also accepted inside the hash query for convenience:
 *   https://feat1.scandpe.fr/#/ai-map-iframe/?key=<KEY>
 *
 * When the key matches REACT_APP_AI_MAP_IFRAME_KEY, the login gate is skipped.
 * An empty/undefined env value disables the bypass entirely.
 */
export const IFRAME_KEY_PARAM = "key";

/**
 * Reads a query param from the top-level query string (before the hash router part),
 * falling back to the query inside the hash.
 */
export const getUrlParam = (name: string): string | null => {
  const fromSearch = new URLSearchParams(window.location.search).get(name);
  if (fromSearch) return fromSearch;

  const hashQueryIndex = window.location.hash.indexOf("?");
  if (hashQueryIndex === -1) return null;
  return new URLSearchParams(window.location.hash.slice(hashQueryIndex + 1)).get(name);
};

export const getIframeKeyFromUrl = (): string | null => getUrlParam(IFRAME_KEY_PARAM);

export const hasValidIframeKey = (): boolean => {
  const expected = (process.env.REACT_APP_AI_MAP_IFRAME_KEY || "").trim();
  if (!expected) return false;
  return getIframeKeyFromUrl() === expected;
};
